import React, { Component } from "react";
import Header from "../../Components/MainLayout/Header";
import { connect } from "react-redux";
import Axios from "axios";
import DownloadCard from "../../Components/Downloads/DownloadCard";
import noData from "../../Assets/img/noData.png";
import Skeleton from "react-loading-skeleton";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class Downloads extends Component {
  state = {
    uploadContent: [],
    loading: true,
    fakeData: [1, 2, 3, 4],
  };
  componentDidMount() {
    window.scrollTo(0, 0);
    this.fetchuploadContent({
      school: this.props.user.user.school.id,
      status: "true",
      available_for: this.props.user.role.id,
      session: this.props.user.session.id,
      for_class: this.props.user.student_class.id,
    });
  }

  fetchuploadContent = (params = {}) => {
    Axios.get(`/api/uploadcontent`, {
      params: { ...params },
    })
      .then((res) => {
        this.setState({
          uploadContent: res.data.results,
        });
        this.setState({
          loading: false,
        });
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };

  render() {
    return (
      <div>
        <Header title="Academic Downloads" />
        <div className="container pt-3">
          {this.state.loading
            ? this.state.fakeData?.map((item, index) => {
                return (
                  <div
                    key={index}
                    className="border p-3 shadow-sm rounded-lg mb-3"
                  >
                    <Skeleton />
                  </div>
                );
              })
            : null}

          {this.state.uploadContent.length !== 0 && !this.state.loading
            ? this.state.uploadContent?.map((item, index) => (
                <div className="pt-3" key={index}>
                  <DownloadCard
                    date={item.date_upload}
                    id={item.id}
                    title={item.content_title}
                    num={index}
                    desc={item.description}
                  />
                </div>
              ))
            : null}

          {this.state.uploadContent.length === 0 &&
          this.state.loading === false ? (
            <div className="px-5 py-5">
              <img className="w-100 mt-5" src={noData} alt="No Data Found" />
              <p className="text-center th-14 th-bold mt-5">No Downloads!</p>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}
export default connect(mapStateToProps)(Downloads);
